import apiClient from '../configServices'
import NProgress from 'nprogress'

apiClient.interceptors.request.use(config => {
    NProgress.start()
    return config
})
apiClient.interceptors.response.use(response => {
    NProgress.done(true)
    return response
})

export default {
    getInterventionPlanReport(id) {
        return apiClient.get('/player/' + id + '/interventionPlanReport')
    },
    async getFilteredReport(item) {
        if (item.intervention_id && item.period_id) {
            return await apiClient.get('/player/' + item.player_id + "/interventionPlanReport" + "?intervention_id=" + item.intervention_id
                + "&period_id=" + item.period_id)
        }
        else {
            if (item.intervention_id) {
                return await apiClient.get('/player/' + item.player_id + "/interventionPlanReport" + "?intervention_id=" + item.intervention_id)
            } else {
                if (item.period_id) {
                    return await apiClient.get('/player/' + item.player_id + "/interventionPlanReport" + "?period_id=" + item.period_id)
                }
                else {
                    return await apiClient.get('/player/' + item.player_id + '/interventionPlanReport   ')
                }
            }
        }
    }
}